export function largeNumberFormatted(amount, noDecimal) {
    let options = {}
    if (!noDecimal) {
        options = { minimumFractionDigits: 1 }
    }
    return Intl.NumberFormat('en-CA', options).format(amount.value);
}

export function largeNumberFormattedDollar(amount) {
    if (+amount.value === 0)
        return ''
    let formatter = Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0});
    return formatter.format(amount.value)
}
